let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("15qow")).then(() => parcelRequire('cUl0q'));